import SelectGridPopup from "./SelectGridPopup";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectGrid(callback, selectable) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      C: function C() {
        return /*#__PURE__*/_jsx(SelectGridPopup, {
          callback: callback,
          selectable: selectable
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}